import { render, staticRenderFns } from "./QLabelSwitch.vue?vue&type=template&id=110c3396&scoped=true"
import script from "./QLabelSwitch.vue?vue&type=script&lang=js"
export * from "./QLabelSwitch.vue?vue&type=script&lang=js"
import style0 from "./QLabelSwitch.vue?vue&type=style&index=0&id=110c3396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110c3396",
  null
  
)

export default component.exports